import { render, staticRenderFns } from "./CopyClinicNoNote.vue?vue&type=template&id=b6a61034&scoped=true"
import script from "./CopyClinicNoNote.vue?vue&type=script&lang=js"
export * from "./CopyClinicNoNote.vue?vue&type=script&lang=js"
import style0 from "./CopyClinicNoNote.vue?vue&type=style&index=0&id=b6a61034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a61034",
  null
  
)

export default component.exports